import { styled } from "@mui/material/styles";

const StyledNoData = styled("div")(
  ({ theme }) => `
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

.text-container{
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
    justify-content: center;
    gap: 12px;
    flex-direction: column;
padding-bottom: 80px;
}

.icon{
min-width: 70px;
min-height: 70px;
border-radius: 127.27px;
background: ${theme.palette.customColor.lightBeige};
}

  .heading {
  font-family: Lexend;
font-weight: 400;
font-size: 20px;
line-height: 100%;
color: ${theme.palette.primary.main};
text-align: center;
  }

    .subHeading {
    font-family: Lexend;
font-weight: 300;
font-size: 14px;
line-height: 22px;
text-align: center;
vertical-align: middle;
color: ${theme.palette.customColor.secondarySecond};
width: 70%;
}

`
);

export default StyledNoData;
